import { all, call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"

import {
  GET_TEMPLATE_SURVEY_WATCHER,
  UPLOAD_TEMPLATE_WATCHER,
  SAVE_TEMPLATE_WATCHER,
  GET_SURVEY_SUMMARY_WATCHER,
} from "./constants"

import {
  getTemplateSuccess,
  getTemplateFailed,
  uploadTemplateSuccess,
  uploadTemplateFailed,
  saveTemplateProgress,
  saveTemplateSuccess,
  getSurveySummarySuccess,
  getSurveySummaryFailed,
} from "./actions"

import { operationSurveySegment } from "../../utils/segment/Survey/surveyTrack"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"
import {
  getSurveyEnps,
  getSurveyQualitative,
  getSurveySummary,
} from "../../utils/routes/routes-survey"
import TplMsg from "../../components/TplMsg"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET EXCEL
function getSurveyTemplateApi(action) {
  woopraTrack("Descargar plantilla Cuestionario")
  const template = action.template ? "/template" : ""
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/survey/${
      action.id
    }/export/xlsx${template}`,
  })
}

function getSurveyTemplateApiProgress() {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/export/xlsx/progress`,
  })
}

function donwloadSurveyTemplate(url) {
  location.replace(url)
}

export function* getSurveyTemplateSaga(action) {
  const survey = yield call(getSurveyWatcherApi, {
    id_survey: action.payload.id,
  })
  try {
    yield call(messageProgress, "Descargando plantilla")
    yield call(getSurveyTemplateApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getSurveyTemplateApiProgress)

      if (data.status === 200) {
        break
      }
    }
    yield call(messageDestroy)
    yield call(donwloadSurveyTemplate, data.data[0].url)
    yield call(
      messageSuccess,
      getStatusSurveyExportTemplate("Plantilla descargada", survey, 1, "")
    )
    yield put(getTemplateSuccess())
  } catch (e) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusSurveyExportTemplate(
        "Error al descargar la plantilla",
        survey,
        1,
        ""
      )
    )
    yield put(getTemplateFailed())
  }
}

// UPLOAD TEMPLATE
function uploadTemplate(payload) {
  woopraTrack("Importar Archivo Cuestionario")
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/survey/${
      payload.id
    }/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload.file,
  })
}

function uploadTemplateProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

function uploadTemplateSummary(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/import/xlsx/summary`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

// GET SURVEY
export function getSurveyWatcherApi(payload) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${payload.id_survey}/summary`,
    params: payload,
  })
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let result = yield call(uploadTemplate, action.payload)
    result = result.data
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress, { timestamp: result.timestamp })

      if (data.status === 200) {
        break
      }
    }
    const otherData = yield call(uploadTemplateSummary, {
      timestamp: result.timestamp,
    })
    yield put(uploadTemplateSuccess(otherData.data[0]))
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
    yield put(uploadTemplateFailed())
  }
}

// SAVE EXCEL
function saveTemplateApi(payload) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/import/xlsx/confirm`,
    params: payload,
  })
}

function saveTemplateProgressApi(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

export function* saveTemplateSaga(action) {
  const survey = yield call(getSurveyWatcherApi, action.payload)
  try {
    yield call(saveTemplateApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))

      data = yield call(saveTemplateProgressApi, action.payload)
      yield put(saveTemplateProgress(data.data[0].percentage))
      if (data.status === 200) {
        getStatusSurveyExportTemplate(
          "Preguntas importadas con exito!",
          survey,
          2,
          action.payload.params
        )
        yield put(saveTemplateSuccess(data))
        break
      }
    }
  } catch (e) {
    getStatusSurveyExportTemplate(
      "Save Template Error!",
      survey,
      2,
      action.payload.params
    )
  }
}

function getStatusSurveyExportTemplate(
  status,
  survey,
  type_operation,
  summary
) {
  switch (type_operation) {
    case 1:
      operationSurveySegment(
        status,
        survey.data.data.survey.survey_type,
        "exportTemplateSurvey",
        ""
      )
      break
    case 2:
      operationSurveySegment(
        status,
        survey.data.data.survey,
        "importSurvey",
        summary
      )
      break
  }
  return status
}

export function* getSurveySummarySaga(action) {
  try {
    let [
      dataSurvey,
      dataQualitative,
      dataEnps,
      { data: surveyData },
    ] = yield all([
      call(getSurveySummary, action.payload),
      call(getSurveyQualitative, action.payload),
      call(getSurveyEnps, action.payload),
      call(getSurveyWatcherApi, { id_survey: action.payload }),
    ])
    dataSurvey = dataSurvey.data.summary
    dataQualitative = dataQualitative.data
    dataEnps = dataEnps.data
    const data = {
      isData:
        dataSurvey.length > 0 ||
        dataQualitative.length > 0 ||
        dataEnps.length > 0,
      surveyData: surveyData.data.survey || {},
    }
    yield put(getSurveySummarySuccess(data))
  } catch (e) {
    if (e.message) {
    } else {
      const { data } = e.response.data
      TplMsg({ text: data.error.message, type: "error" })
    }
    yield put(getSurveySummaryFailed(data))
  }
}

export default function* getSurveyWatcherSaga() {
  yield takeLatest(GET_TEMPLATE_SURVEY_WATCHER, getSurveyTemplateSaga)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
  yield takeLatest(SAVE_TEMPLATE_WATCHER, saveTemplateSaga)
  yield takeLatest(GET_SURVEY_SUMMARY_WATCHER, getSurveySummarySaga)
}
